<div class="trustee-contact-type-badge">
  <div [class]="contactType$ | async"
       class="lifeislife-badge contact-type-colored trustee-contact-type"
       [title]="showTrusteeLabelTitle ? (trusteeLabel$ | async) : ''"
  >
    <app-trustee-contact-type [contactType]="contactType$ | async"
    ></app-trustee-contact-type>
  </div>
</div>
